var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCctv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fill-icon{fill:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cctv"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "fill-icon",
    x: 15,
    y: 33.33,
    width: 100,
    height: 13.33,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-icon",
    d: "M68.33,52.67V63.1a13.33,13.33,0,1,1-6.66,0V52.67h-40a43.33,43.33,0,0,0,86.66,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-icon",
    d: "M65,65.33A10.67,10.67,0,1,0,75.67,76,10.67,10.67,0,0,0,65,65.33ZM65,80a4,4,0,1,1,4-4A4,4,0,0,1,65,80Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCctv);
export default __webpack_public_path__ + "static/media/cctv.042c1804fd84ac51bb371da9c2bf270a.svg";
export { ForwardRef as ReactComponent };